import { render, staticRenderFns } from "./WaterOnPaperDryMassSection.vue?vue&type=template&id=63bfe9c1&scoped=true&"
import script from "./WaterOnPaperDryMassSection.vue?vue&type=script&lang=js&"
export * from "./WaterOnPaperDryMassSection.vue?vue&type=script&lang=js&"
import style0 from "./WaterOnPaperDryMassSection.vue?vue&type=style&index=0&id=63bfe9c1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bfe9c1",
  null
  
)

export default component.exports